<template>
  <div class="dw-footer-main" style="margin-top:-10px;">
    <div>
      <span><a href="http://xingcelun.com" style="color: #333;"><strong>Powered by coding 版权所有 © 2020</strong></a>&nbsp;</span>
    </div>
    <div>
      <span><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" style="text-decoration: none;color: #333;">鲁ICP备20017349号-1</a></span>
      <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37110202000282"><strong>鲁公网安备37110202000282号</strong></a></span>
    </div>
    <div>
      <span>更好体验，请使用谷歌浏览器</span>
    </div>
  </div>
</template>
<script>

import API from '@/api/index.js'

export default {
  name: 'DwFooter',
  data () {
    return {
      footerInfo: {
        siteName: '百度',
        siteUrl: 'http://www.baidu.com',
        siteIcp: '京ICP备13050030号-3',
        siteMail: 'service@diaowen.net',
        sitePhone: '18888888888',
        versionInfo: 'DWSurvey OSS V5.0 Vue',
        versionNumber: 'OSS V5.0',
        versionBuilt: '20211128',
        years: '2012-2021'
      }
    }
  },
  mounted () {
    this.queryDWSurveyFooter()
  },
  methods: {
    queryDWSurveyFooter () {
      this.axios.get(API.surveyFooterInfo, {}).then((response) => {
        const resultData = response.data.data
        console.debug(resultData)
        this.footerInfo = resultData
      })
    }
  }
}
</script>

<style scoped>
.dw-footer-main{
  text-align: center;
  font-size: 12px;
  color: grey;
  line-height: 30px;
  padding-top: 0px;
  padding-bottom: 10px;
}
.dw-footer-main a{
  text-decoration: none;
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwFooter.vue